"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _ProductOwnershipSelectors = require("../../selectors/ProductOwnershipSelectors");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _TermIds = require("self-service-api/constants/TermIds");

var _Hubs = require("self-service-api/constants/Hubs");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _ActiveHubSelectors = require("../../selectors/ActiveHubSelectors");

var _urls = require("../../utils/urls");

var _GatingSelectors = require("../../selectors/GatingSelectors");

var LocaleToLearnMoreUrl = {
  en: 'https://offers.hubspot.com/updates-to-sales-hub-professional-march-2020',
  es: 'https://offers.hubspot.es/actualizacion-sales-hub-pro-2020',
  fr: 'https://offers.hubspot.fr/mise-a-jour-hub-sales-pro-mars-2020',
  de: 'https://offers.hubspot.de/updates-sales-hub-professional',
  ja: 'https://offers.hubspot.jp/updates-to-sales-hub-professional-march-2020',
  pt: 'https://br.hubspot.com/ofertas/updates-to-sales-hub-professional-march-2020'
};

var SalesProSeatPriceChangeBanner = function SalesProSeatPriceChangeBanner(_ref) {
  var activeHub = _ref.activeHub,
      currencyCode = _ref.currencyCode,
      ownsLegacySalesPro = _ref.ownsLegacySalesPro,
      salesProSeatPrice = _ref.salesProSeatPrice,
      isUngatedForSeatPriceChangeBanner = _ref.isUngatedForSeatPriceChangeBanner;

  if (!ownsLegacySalesPro || activeHub !== _Hubs.HUB_SALES || !isUngatedForSeatPriceChangeBanner) {
    return null;
  }

  return _react.default.createElement(_UIAlert.default, {
    titleText: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "salesProSeatPriceChange.title_jsx",
      elements: {
        Price: _PriceDisplay.default
      },
      options: {
        currencyCode: currencyCode,
        price: salesProSeatPrice.monthly.calculatedPrice
      }
    })
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "salesProSeatPriceChange.body_jsx",
    elements: {
      UILink: _UILink.default
    },
    options: {
      href: (0, _urls.langToUrl)(LocaleToLearnMoreUrl)
    }
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    ownsLegacySalesPro: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL),
    salesProSeatPrice: (0, _PricingSelectors.calculatedPriceSelector)(state, {
      merchandiseId: _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019,
      termId: _TermIds.MONTHLY_NO_DISCOUNT,
      itemConfigurations: [{
        merchandiseId: _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019,
        quantity: 1
      }]
    }),
    isUngatedForSeatPriceChangeBanner: (0, _GatingSelectors.isUngatedSelector)(state, 'Apr1SalesProSeatBanner')
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SalesProSeatPriceChangeBanner);

exports.default = _default;
module.exports = exports.default;